module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "parts-nav-footer-alias",
    class: _vm.classes
  }, _vm._l((_vm.list), function(ref, index) {
    var target = ref.target;
    var url = ref.url;
    var icon = ref.icon;
    var text = ref.text;
    var subSign = ref.subSign;

    return _c('li', {
      key: index,
      staticClass: "parts-nav-footer-alias__item"
    }, [_c('ext-link', {
      staticClass: "parts-nav-footer-alias__link",
      attrs: {
        "target": target,
        "to": url
      }
    }, [_c('img', {
      staticClass: "parts-nav-footer-alias__img",
      attrs: {
        "src": icon,
        "alt": text
      }
    }), (subSign) ? _c('span', {
      staticClass: "parts-nav-footer-alias__text",
      domProps: {
        "innerHTML": _vm._s(subSign)
      }
    }) : _vm._e()])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed8ecf0","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/nav/FooterAlias.vue
// module id = 15d127c7fc7226e9c9c9
// module chunks = 0